var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "voiceSceneDetail" } }, [
    _c("div", { staticClass: "top" }, [
      _c("a", { staticClass: "btn-end", on: { click: _vm.endScene } }, [
        _vm._v("结束考核")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "hawkeye" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "header" }, [_vm._v("考核得分与建议")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _vm.isHasData
              ? [
                  _vm.gradeState == 1
                    ? [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("p", [_vm._v("讲师正在对你的考核打分")]),
                        _vm._v(" "),
                        _c("p", [_vm._v("预计需要3分钟，请稍等…")])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.gradeState == 2
                    ? [
                        _vm.effectStatus == 0
                          ? [
                              _vm._m(2),
                              _vm._v(" "),
                              _c("p", [_vm._v("本次考核无效")]),
                              _vm._v(" "),
                              _vm.isCurrent
                                ? _c("p", [_vm._v("你还有1次考核机会")])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("p", { staticClass: "wuxiao" }, [
                                _vm._v(_vm._s(_vm.effectReason))
                              ])
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.effectStatus == 1
                          ? [
                              _c("div", { staticClass: "video" }, [
                                _c("span", [_vm._v("考核录音")]),
                                _vm._v(" "),
                                _c("audio", {
                                  attrs: {
                                    src: _vm.videoUrl,
                                    controls: "controls"
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "score" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "title",
                                      staticStyle: {
                                        "justify-content": "space-between"
                                      }
                                    },
                                    [
                                      _c("div", [
                                        _c("span", [_vm._v("考核结果")]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              blue: _vm.passedStatus,
                                              red: !_vm.passedStatus
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.gradeScore) + "分"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.passedStatus
                                        ? _c(
                                            "span",
                                            {
                                              class: {
                                                blue: _vm.passedStatus,
                                                red: !_vm.passedStatus
                                              }
                                            },
                                            [_vm._v("已通过，请尽快完成结业课")]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              class: {
                                                blue: _vm.passedStatus,
                                                red: !_vm.passedStatus
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "没有通过考核，需要继续加油哦"
                                              )
                                            ]
                                          )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.gradeList, function(f, index) {
                                    return _c(
                                      "div",
                                      { staticClass: "grade" },
                                      [
                                        _c("div", { staticClass: "first" }, [
                                          _c("span", { staticClass: "name" }, [
                                            _vm._v(_vm._s(f.name))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "blue gradescore" },
                                            [
                                              _vm._v(
                                                _vm._s(f.gradeScore) + "分"
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(f.childList, function(s, key) {
                                          return _c(
                                            "div",
                                            { staticClass: "second" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "parent" },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "name" },
                                                    [_vm._v(_vm._s(s.name))]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "red gradescore"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          s.gradeScore < 0
                                                            ? s.gradeScore
                                                            : "-" +
                                                                (s.score -
                                                                  s.gradeScore)
                                                        ) + "分"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    key: key + _vm.keyData,
                                                    class: {
                                                      "el-icon-arrow-right": !s.isClickSecond,
                                                      "el-icon-arrow-down":
                                                        s.isClickSecond
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.clickSecond(
                                                          index,
                                                          key
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(s.childList, function(
                                                t,
                                                key
                                              ) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: key + _vm.keyData,
                                                    class: {
                                                      third: true,
                                                      none: !s.isClickSecond
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "name" },
                                                      [_vm._v(_vm._s(t.name))]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "red gradescore"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(t.gradeScore) +
                                                            "分"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              })
                                            ],
                                            2
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "evaluate" },
                                [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _vm._l(_vm.evaluateList, function(e, key) {
                                    return _c("p", [
                                      _c("span", { staticClass: "dot" }),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(key + 1) +
                                          "、" +
                                          _vm._s(e) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  })
                                ],
                                2
                              )
                            ]
                          : _vm._e()
                      ]
                    : _vm._e()
                ]
              : [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("p", [_vm._v("完成本次考核后")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("讲师将为你本次的考核打分")])
                ]
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _vm.gradeState == 1
      ? _c("div", { staticClass: "confirmbox-bg" })
      : _vm._e(),
    _vm._v(" "),
    _vm.gradeState == 1
      ? _c("div", { staticClass: "confirmbox" }, [
          _vm._m(5),
          _vm._v(" "),
          _vm._m(6)
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "iframe-box" }, [
        _c("iframe", {
          attrs: {
            src: "/customer/action/workbench/index",
            width: "100%",
            height: "100%",
            frameborder: "0"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: require("@/assets/images/voiceScene/icon_dafen.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: require("@/assets/images/voiceScene/icon_wuxiao.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("讲师建议")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: require("@/assets/images/voiceScene/icon_kong.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("span", { staticClass: "tip" }, [_vm._v("提示")]),
      _vm._v(" "),
      _c("span", { staticClass: "el-icon-close" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _c("img", {
          attrs: { src: require("@/assets/images/voiceScene/icon_tips.png") }
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("讲师正在对你的考核打分，请耐心等待~")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-130a61a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-130a61a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/voiceScene/kaoheDetail.vue
// module id = 1514
// module chunks = 0